import React from 'react';

import {Anchor, Button} from '@newsela/angelou';
import {cx} from 'emotion';
import PropTypes from 'prop-types';

import withTrackEvent from 'static/three-oh/src/components/with/WithTrackEvent';

import {ReactComponent as CleverSvg} from '../assets/CleverSSO.svg';
import styles from '../styles';

const propTypes = {
  actionName: PropTypes.string,
  additionalClassName: PropTypes.string,
  anchorText: PropTypes.string.isRequired,
  ariaProps: PropTypes.object,
  href: PropTypes.string.isRequired,
  buttonHandler: PropTypes.func,
  iconClassName: PropTypes.string,
  eventProperties: PropTypes.object,
  legacyEventName: PropTypes.string,
  streamProperties: PropTypes.object,
};


const AnchorWithTrackEvent = withTrackEvent(Anchor);

const CleverAnchor = ({
  actionName,
  additionalClassName,
  anchorText,
  ariaProps,
  href,
  buttonHandler,
  iconClassName,
  eventProperties,
  legacyEventName,
  streamProperties,
}) => {
  return (
    <AnchorWithTrackEvent
      href={href}
      onClick={buttonHandler ? (e) => buttonHandler(e, href) : null}
      __classNameFor={{
        root: additionalClassName
      }}
      styleAnchorAsButton={{
        legacy_flavor: Button.legacy_flavor.solid,
        legacy_statusColor: Button.legacy_statusColor.primary,
        legacy_size: Button.legacy_size.justified
      }}
      __cssFor={{
        root: `
          background-color: ${styles.cleverBrandColor};
          &:hover, &:focus {
            background: linear-gradient(0deg, rgba(29, 29, 29, 0.15), rgba(29, 29, 29, 0.15)), ${styles.cleverBrandColor};
          }
          padding-left: 0.3rem;
          &[disabled] {
            background-color: ${styles.cleverBrandColor};
          }
        `
      }}
      ariaProps={ariaProps}
      dataProps={{
        'data-qa-selector': 'clever_link',
        id: 'clever_link'
      }}
      objectType="User"
      actionName={actionName}
      eventProperties={eventProperties}
      legacyEventName={legacyEventName}
      streamProperties={streamProperties}
    >
      <div className={styles.socialLinkDescription}>
        <CleverSvg
          aria-hidden="true"
          className={cx([styles.cleverIcon, iconClassName])}
        />
        <span className={styles.linkLabel}>{anchorText}</span>
      </div>
    </AnchorWithTrackEvent>
  );
};

CleverAnchor.propTypes = propTypes;

export default CleverAnchor;
